module.exports = __webpack_public_path__ + "static/media/8790.c2656df3.png";